// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__ntI8p","container":"footer_container__Vxpdo","navItem":"footer_navItem__s4TKu","copyright":"footer_copyright__PXx0z"};